<template>
	<div class="header__shopnav" v-if="categories.length">
		<nav class="nav-shop">
			<ul class="nav-shop__list">
				<li
					v-if="showPersonalStartpage"
					class="nav-shop__item nav-shop__item--icon"
				>
					<a
						class="nav-shop__item-link nav-shop__item-link--icon"
						:class="{
							'nav-shop__item-link--active': activeCategory == favoriteCode
						}"
						@click="onFavoriteProducts"
						:title="$t('shoplist.favorites.title')"
					>
						<SVGHeartFull
							v-if="activeCategory == favoriteCode"
							class="nav-shop__item-icon"
						/>
						<SVGHeart
							v-else
							class="nav-shop__item-icon"
						/>
					</a>
				</li>
				<li
					class="nav-shop__item"
					v-for="category in categories"
					:key="category.code"
				>
					<a
						class="nav-shop__item-link"
						:class="{
							'nav-shop__item-link--active':activeCategory == category.code
						}"
						@click="onChangeCategory(category)"
						v-html="category.name"
					/>
				</li>
			</ul>
		</nav>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import urlWatcher from '@/helpers/urlwatcher'

export default {
	computed: {
		...mapGetters("productlist", [
			"products",
			"categories",
			"filters",
			"filtersActive",
			"currentTaxon",
			"currentTaxonPath",
			"currentSubCategories",
			"favoriteCode",
			"productsLoading",
		]),
		...mapGetters("account", [
			"isLoggedIn",
			"lastOrders",
			"favoriteProducts",
			"accountUserDetail"
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		showPersonalStartpage() {
			return !!(this.isLoggedIn && (this.favoriteProducts.length || this.lastOrders.length));
		},
		activeCategory() {
			return this.currentTaxon == this.favoriteCode ? this.favoriteCode : this.currentTaxonPath[0] && this.currentTaxonPath[0].code
		},
	},
	methods: {
		onChangeCategory(category) {
			let toCat = category.code;
			urlWatcher.change({taxon: toCat, product: null})
		},
		onFavoriteProducts() {
			urlWatcher.change({taxon: this.favoriteCode, product: null})
		},
	}
}
</script>

<style>

</style>
